export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><path d=\"M25 27V4a1 1 0 00-1-1h-3V1a.998.998 0 00-1.243-.97l-12 3A1 1 0 007 4v23H2v2h5.876l11.881 2.97a1.004 1.004 0 00.858-.182A.998.998 0 0021 31v-2h9v-2zm-6 2.719l-10-2.5V4.781l10-2.5zM23 27h-2V5h2z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};